import { render, staticRenderFns } from "./DialogEditCollaboratorAccess.vue?vue&type=template&id=de36c32a"
import script from "./DialogEditCollaboratorAccess.vue?vue&type=script&lang=js"
export * from "./DialogEditCollaboratorAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports